import { GetApi, PostApi, DeleteApi } from "../../services/ApiService";

export const getPoolDetails = async (setloading, userId) => {
  try {
    setloading(true);
    let response = await GetApi(
      userId ? `/user/getpoolsByUser/${userId}` : `/pools`
    );
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return "";
  }
};

// Add New Pool
export const addPool = async (setloading, data) => {
  try {
    setloading(true);
    let response = [];
    response = await PostApi(`/pools/create`, data);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

// Active Pool By User Id
export const activePool = async (setloading, data) => {
  try {
    setloading(true);
    let response = [];
    response = await PostApi(`/user/assignLocation`, data);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

// deleet pool by pool Id
export const deletePool = async (setloading, poolId) => {
  try {
    setloading(true);
    let response = [];
    response = await DeleteApi(`/pools/${poolId}`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};
